import { FETCH_INCIDENTS_COUNT_ASYNC } from './constants'

const getIncidentsCount = (params) => ({
  type: FETCH_INCIDENTS_COUNT_ASYNC.INITIATE,
  payload: { params },
})
export const getIncidentsCountSuccess = (data) => ({
  type: FETCH_INCIDENTS_COUNT_ASYNC.SUCCESS,
  payload: { data },
})
export const getIncidentsCountError = (error) => ({
  type: FETCH_INCIDENTS_COUNT_ASYNC.ERROR,
  error,
})
const getIncidentsCountCancel = () => ({
  type: FETCH_INCIDENTS_COUNT_ASYNC.CANCEL,
})

export default {
  // to props
  getIncidentsCount,
  getIncidentsCountCancel,
}
